import React from 'react';
import { Box, Typography } from '@mui/material';
import BlogsIcon from '../components/BlogsIcon';
import { color, font } from '../styles/tokens';

const Home = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center', px: 3,
        background: `radial-gradient(900px 420px at 50% -10%, ${color.cyanGlow}, transparent 60%), ${color.ink}`,
      }}
    >
      <Box sx={{ width: 56, height: 56, borderRadius: '50%', background: '#fff', display: 'grid', placeItems: 'center', overflow: 'hidden', mb: 3 }}>
        <BlogsIcon style={{ width: 56, height: 56, borderRadius: 0, boxShadow: 'none' }} />
      </Box>
      <Typography sx={{ fontFamily: font.mono, fontSize: '.6875rem', letterSpacing: '.14em', textTransform: 'uppercase', color: color.cyan, mb: 1 }}>
        TGPS Global &middot; editorial control room
      </Typography>
      <Typography sx={{ fontFamily: font.display, fontWeight: 700, fontSize: { xs: '1.8rem', sm: '2.4rem' }, color: color.bone, mb: 2 }}>
        Wire Desk
      </Typography>
      <Typography sx={{ color: color.boneDim, maxWidth: 460 }}>
        Share your thoughts and ideas with the world.
      </Typography>
    </Box>
  );
};

export default Home;
